import firebase from 'firebase'
import axios from 'axios'

export default {
  state: {
    user: {
      loggedIn: false,
      isFetching: true,
      data: null,
    },
    firestoreData: {
      isAdmin: false,
      suspended: false,
      name: '',
      email: '',
      languages: [],
      translations: [
        {
          from: '',
          to: '',
        },
      ],
      rating: {
        quality: 0,
        availability: 0,
        deadlines: 0,
        cooperation: 0,
      },
      comment: '',
      rates: {
        currency: '€',
        word: 0,
        review: 25,
      },
      lastMonth: {
        wordCount: '',
        fee: '',
      },
    },
    users: [],
    linkBuilderAdmins: [],
  },
  actions: {
    fetchLinkBuilderAdminList({ commit, state }) {
      axios.get('https://europe-west1-freelance-ffddb.cloudfunctions.net/get-admins').then(response => {
        commit('SET_LINKBUILDER_ADMINS', response.data)
      })
    },

    async fetchUserInformation({ commit, dispatch, state }, user) {
      let { firestoreData } = state

      commit('SET_IS_FETCHING', true)
      commit('SET_LOGGED_IN', user !== null)

      if (!user) {
        commit('SET_USER', null)
        return commit('SET_IS_FETCHING', false)
      }

      let userData = {
        uid: user.uid,
        email: user.email,
        emailVerified: user.emailVerified,
        displayName: user.displayName,
        firestore: firestoreData,
      }

      var doc = await firebase
        .firestore()
        .collection('users')
        .doc(userData.uid)
        .get()

      if (doc.exists) {
        for (let key in doc.data()) {
          userData.firestore[key] = doc.data()[key]
        }
        if (userData.firestore.isAdmin) {
          await dispatch('fetchUsers')
        }
      } else {
        console.log('No such document! Adding new user...')
        userData.firestore.name = user.displayName
        userData.firestore.email = user.email
        await dispatch('createUser', { uid: user.uid, data: userData.firestore })
      }
      commit('SET_USER', userData)
      commit('SET_IS_FETCHING', false)
    },
    logoutUser({ commit }, data) {
      commit('SET_LOGGED_IN', false)
      commit('SET_USER', data)
    },
    async fetchUsers({ commit, state }) {
      try {
        const querySnapshot = await firebase
          .firestore()
          .collection('users')
          .get()

        let userList = []

        querySnapshot.forEach(doc => {
          let firestoreObj = { ...state.firestoreData }
          for (let key in doc.data()) {
            firestoreObj[key] = doc.data()[key]
          }
          userList.push({ id: doc.id, content: firestoreObj })
        })
        commit('SET_USERS', userList)
      } catch (error) {
        console.error('Error getting users documents: ', error)
      }
    },
    async fetchUserById({ commit }, { userId }) {
      return (
        await firebase
          .firestore()
          .collection('users')
          .doc(userId)
          .get()
      ).data()
    },
    async createUser(context, { uid, data }) {
      try {
        const doc = await firebase
          .firestore()
          .collection('users')
          .doc(uid)
          .set(data)
      } catch (err) {
        console.log('Error creating user', err)
      }
    },
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value
    },
    SET_USER(state, data) {
      state.user.data = data
    },
    SET_IS_FETCHING(state, value) {
      state.user.isFetching = value
    },
    SET_USERS(state, data) {
      state.users = data
    },
    SET_LINKBUILDER_ADMINS(state, data) {
      state.linkBuilderAdmins = data
    },
  },
  getters: {
    user(state) {
      return state.user
    },
    userId(state) {
      return state.user.data.uid
    },
    users(state) {
      return state.users.sort((a, b) => (a.content.name > b.content.name ? 1 : -1))
    },
    freelancers(state) {
      let users = state.users.filter(user => {
        return !user.isAdmin
      })
      users.sort((a, b) => (a.content.name > b.content.name ? 1 : -1))
      return users
    },
    linkBuilderAdmins(state) {
      let linkBuilderAdmins = state.linkBuilderAdmins
      linkBuilderAdmins.sort((a, b) => (a.name > b.name ? 1 : -1))
      return linkBuilderAdmins
    },
    userName: state => id => {
      return state.users.find(user => user.id === id).content.name
    },
  },
}
